import { createFileRoute } from '@tanstack/react-router';

import { staticPageHead } from '@/config/seo-head';
import { ProjectsIndexPage } from '@/features/projects/components/projects-index-page';
import { loadPublishedProjects } from '@/features/projects/project-loaders';

export const Route = createFileRoute('/projects/')({
  head: () => staticPageHead('/projects'),
  loader: () => loadPublishedProjects(),
  component: ProjectsIndexRoute,
});

function ProjectsIndexRoute() {
  const projects = Route.useLoaderData();
  return <ProjectsIndexPage projects={projects} />;
}
